import { ChatContent } from 'api/mutations/chat/types'
import { ChatInputValues } from 'validations/ChatInputSchema'
import { getChatImageMimeType } from 'utils/getChatImageMimeType'

const readFileAsBase64 = (file: File) => new Promise<string>((resolve, reject) => {
  const reader = new FileReader()
  reader.onload = () => resolve(String(reader.result).split(',')[1])
  reader.onerror = () => reject(reader.error)
  reader.readAsDataURL(file)
})

const toAttachmentContent = async (file: File): Promise<ChatContent> => {
  const data = await readFileAsBase64(file)
  const imageMimeType = getChatImageMimeType(file)

  if (imageMimeType) {
    return {
      type: 'image_url',
      image_url: { url: `data:${imageMimeType};base64,${data}` },
    }
  }

  return {
    type: 'file',
    file: {
      name: file.name,
      mime: file.type || 'application/octet-stream',
      data,
    },
  }
}

const toMessageContent = async ({ message, attachments }: ChatInputValues) => {
  const files = await Promise.all(attachments.map(({ file }) => toAttachmentContent(file)))
  const text: ChatContent[] = message ? [{ type: 'text', text: message }] : []

  return [...text, ...files]
}

export { toMessageContent }
